<template>
    <div class="pt-[20px] bg-[#ededed]">
        <div class="max-w-[1400px] w-full container mx-auto">
            <div
                class="pt-[60px] pr-[20px] pb-[2%] pl-[10px] max-w-[1400px]"
                id="contactsNavigation"
            >
                <contactsNavigation />
            </div>
        </div>
    </div>
    <div class="max-w-[1400px] w-full container mx-auto">
        <div class="pt-[60px] pr-[20px] pb-[40px] pl-[10px] max-w-[1400px]">
            <div class="mb-5" id="contactsForm">
                <h2 class="text-2xl font-semibold">Erweiterte Suche</h2>
                <contactsForm />
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
    import contactsNavigation from '@/components/SubNavigations/TheContactsNavigation.vue'
    import useContactStore from '@/utils/useContactStore'
    import contactsForm from '@/components/Contacts/ContactsForm.vue'

    const { selectedContact } = useContactStore()

    selectedContact.value = null
</script>
